import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import CustomListItem from 'app/components/CustomListItem/CustomListItem';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { RouteConstants } from 'app/routes';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { selectHarvestState } from '../../slice/selectors';
import { ItemsList } from 'app/components/LayoutComponents/LayoutComponents';
import { Tag, List } from 'antd';
import { useResourceSlice } from '../../slice';
import { toFixedIfFloat } from 'utils/helpers';
import {
  selectSelectedCompanyGroupId,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';

interface IProps {}

const HarvestListCard = (props: IProps) => {
  const { t } = useTranslation();

  const history = useHistory();

  const { actions } = useResourceSlice();

  const dispatch = useDispatch();

  const { harvestArr, loading, selectedCultureId } = useSelector(
    selectHarvestState,
  );

  const envId = useSelector(selectSelectedEnvId) as number;
  const companyId = useSelector(selectSelectedCompanyId);
  const companyGroupId = useSelector(selectSelectedCompanyGroupId);

  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    dispatch(actions.getHarvest({ envId, companyId, companyGroupId }));
  }, [envId, dispatch, actions, companyId, companyGroupId]);

  const harvestWithSearch = useMemo(
    () =>
      harvestArr.map(harvestItem => {
        const query = searchQuery.toLowerCase().trim();
        const isActive = harvestItem.culture.id === selectedCultureId;

        if (!query.length) {
          return { ...harvestItem, isVisible: true, isActive };
        }

        const keywordsArr = query.split(' ');
        const isVisible = Boolean(
          keywordsArr.find(k => harvestItem.name.toLowerCase().includes(k)),
        );

        return { ...harvestItem, isVisible, isActive };
      }),
    [harvestArr, searchQuery, selectedCultureId],
  );

  const onListItemClick = (cultureId: number) => () => {
    if (envId) {
      history.push(
        generatePath(RouteConstants.resource.harvestCulture, {
          envId,
          cultureId,
        }),
      );
    }
  };

  return (
    <ItemsList.Card bordered={false}>
      <ItemsList.SearchInput
        prefix={<SearchOutlined />}
        suffix={<InfoCircleOutlined />}
        value={searchQuery}
        onChange={e => setSearchQuery(e.currentTarget.value)}
        placeholder={t('Field.List.SearchPlaceholder', 'Search')}
      />
      <List
        loading={loading}
        itemLayout="horizontal"
        dataSource={harvestWithSearch}
        renderItem={({
          isVisible,
          harvest,
          name,
          culture: { id, name: cultureName },
          isActive,
        }) => {
          return (
            <CustomListItem
              key={id}
              isVisible={isVisible}
              isActive={isActive}
              onClick={onListItemClick(id)}
              actions={[
                <Tag
                  key="0"
                  color={harvest >= 0 ? 'green' : 'red'}
                >{`${toFixedIfFloat(harvest)} T`}</Tag>,
              ]}
            >
              <List.Item.Meta title={name} description={cultureName} />
            </CustomListItem>
          );
        }}
      />
    </ItemsList.Card>
  );
};

export default HarvestListCard;
